import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    setLocationFilterState: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_LOCATION_FILTER_STATE,
                payload: {
                    searchParams: searchParams
                }
            })
        }
    },
    setLocationKeys: (locationKeys) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_LOCATION_KEY_STATE,
                payload: {
                    locationKeys
                }
            })
        }
    },
    setLocationSelectorFilters: (locations, defaultLocationKey) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_LOCATION_SELECTOR_FILTERS,
                payload: {
                    locations: locations,
                    defaultLocationKey: defaultLocationKey
                }
            })
        }
    },
    search: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/search',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.SEARCH_LOCATION_TASK_LIST_REQUEST,
                        types.SEARCH_LOCATION_TASK_LIST_SUCCESS,
                        types.SEARCH_LOCATION_TASK_LIST_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationSelectorFilters: (subscriptionId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/location-selector-filters',
                    method: 'POST',
                    body: { subscriptionId: subscriptionId },
                    types: [
                        types.LOAD_LOCATION_SELECTOR_FILTERS_REQUEST,
                        types.LOAD_LOCATION_SELECTOR_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_SELECTOR_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadInitialLocationSelectorFilters: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/initial-location-selector-filters',
                    method: 'POST',
                    body: request,
                    types: [
                        types.LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_REQUEST,
                        types.LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_SUCCESS,
                        types.LOAD_INITIAL_LOCATION_SELECTOR_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadListFilters: () => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/location-list-filters',
                    method: 'POST',
                    types: [
                        types.LOAD_LOCATION_TASK_LIST_FILTERS_REQUEST,
                        types.LOAD_LOCATION_TASK_LIST_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_TASK_LIST_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadLimitedModeFilters: (taskId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/limited-mode-drawer-filters',
                    method: 'POST',
                    body: { 
                        locationTaskId: taskId
                    },
                    types: [
                        types.LOAD_LIMITED_MODE_FILTERS_REQUEST,
                        types.LOAD_LIMITED_MODE_FILTERS_SUCCESS,
                        types.LOAD_LIMITED_MODE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadProjectCoaches: (taskId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/project-coaches',
                    method: 'POST',
                    body: { 
                        locationTaskId: taskId
                    },
                    types: [
                        types.LOAD_PROJECT_COACHES_REQUEST,
                        types.LOAD_PROJECT_COACHES_SUCCESS,
                        types.LOAD_PROJECT_COACHES_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationTaskDrawerFilters: (taskId, locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/location-task-drawer-filters',
                    method: 'POST',
                    body: { 
                        locationTaskId: taskId,
                        locationKey: locationKey
                    },
                    types: [
                        types.LOAD_LOCATION_TASK_DRAWER_FILTERS_REQUEST,
                        types.LOAD_LOCATION_TASK_DRAWER_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_TASK_DRAWER_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadColumnFilters: (subId, locationKeys) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/location-list-column-filters',
                    method: 'POST',
                    body: { subscriptionId: subId, locationKeys: locationKeys },
                    types: [
                        types.LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_REQUEST,
                        types.LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_SUCCESS,
                        types.LOAD_LOCATION_TASK_LIST_COLUMN_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    updateSavedColumns: (ids) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/location-list-save-columns',
                    method: 'POST',
                    body: { columnIds: ids },
                    types: [
                        types.UPDATE_LOCATION_TASK_LIST_COLUMNS_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIST_COLUMNS_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIST_COLUMNS_FAILURE
                    ]
                }
            });
        }
    },
    updateResponsibleUser: (ids, userId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-responsible-user',
                    method: 'POST',
                    body: { locationTaskIds: ids, responsibleUserId: userId },
                    types: [
                        types.UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIST_RESPONSIBLE_USER_FAILURE
                    ]
                }
            });
        }
    },
    updateDates: (taskId, startDate, targetDate) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-dates',
                    method: 'POST',
                    body: { taskId: taskId, startDate: startDate, targetDate: targetDate },
                    types: [
                        types.UPDATE_LOCATION_TASK_DATES_REQUEST,
                        types.UPDATE_LOCATION_TASK_DATES_SUCCESS,
                        types.UPDATE_LOCATION_TASK_DATES_FAILURE
                    ]
                }
            });
        }
    },    
    searchResponsibleUsers: (locationKeys, searchTerm, signal) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/search-responsible-users',
                    method: 'POST',
                    body: { locationKeys: locationKeys, searchTerm: searchTerm },
                    types: [
                        types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_REQUEST,
                        types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_SUCCESS,
                        types.SEARCH_LOCATION_TASK_RESPONSIBLE_USERS_FAILURE
                    ],
                    signal,
                }
            });
        },
    updateStatus: (ids, statusId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-status',
                    method: 'POST',
                    body: { locationTaskIds: ids, statusId: statusId },
                    types: [
                        types.UPDATE_LOCATION_TASK_LIST_STATUS_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIST_STATUS_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIST_STATUS_FAILURE
                    ]
                }
            });
        }
    },
    updateIsActive: (ids) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-isactive',
                    method: 'POST',
                    body: { locationTaskIds: ids },
                    types: [
                        types.UPDATE_LOCATION_TASK_LIST_ISACTIVE_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIST_ISACTIVE_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIST_ISACTIVE_FAILURE
                    ]
                }
            });
        }
    },
    updateFollowingTasks: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-following-tasks',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: request,
                    types: [
                        types.UPDATE_LOCATION_TASK_LIST_FOLLOW_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIST_FOLLOW_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIST_FOLLOW_FAILURE
                    ]
                }
            });
        }
    },
    loadLocationTask: (id) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/' + id,
                    method: 'GET',
                    types: [
                        types.LOAD_LOCATION_TASK_REQUEST,
                        types.LOAD_LOCATION_TASK_SUCCESS,
                        types.LOAD_LOCATION_TASK_FAILURE
                    ]
                }
            });
        },
    saveLocationTaskLimitedMode: (locationTask) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-limited-mode',
                    method: 'PUT',
                    body: locationTask,
                    types: [
                        types.UPDATE_LOCATION_TASK_LIMITED_MODE_REQUEST,
                        types.UPDATE_LOCATION_TASK_LIMITED_MODE_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LIMITED_MODE_FAILURE
                    ]
                }
            });
        }
    },
    saveLocationTaskEditMode: (locationTask) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-edit-mode',
                    method: 'PUT',
                    body: locationTask,
                    types: [
                        types.UPDATE_LOCATION_TASK_EDIT_MODE_REQUEST,
                        types.UPDATE_LOCATION_TASK_EDIT_MODE_SUCCESS,
                        types.UPDATE_LOCATION_TASK_EDIT_MODE_FAILURE
                    ]
                }
            });
        }
    },
    loadComments: (taskId, sampleSize) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/comments',
                    method: 'POST',
                    body: { locationTaskId: taskId, sampleSize: sampleSize },
                    types: [
                        types.LOAD_LOCATION_TASK_COMMENTS_REQUEST,
                        types.LOAD_LOCATION_TASK_COMMENTS_SUCCESS,
                        types.LOAD_LOCATION_TASK_COMMENTS_FAILURE
                    ]
                }
            });
        }
    },
    loadCommentsPage: (taskId, page, size) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/comments',
                    method: 'POST',
                    body: { locationTaskId: taskId, pageNumber: page, pageSize: size },
                    types: [
                        types.LOAD_LOCATION_TASK_COMMENTS_REQUEST,
                        types.LOAD_LOCATION_TASK_COMMENTS_SUCCESS,
                        types.LOAD_LOCATION_TASK_COMMENTS_FAILURE
                    ]
                }
            });
        }
    },
    createComment: (taskId, comment) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/create-comment',
                    method: 'POST',
                    body: {
                        locationTaskId: taskId,
                        comment
                    },
                    types: [
                        types.CREATE_LOCATION_TASK_COMMENT_REQUEST,
                        types.CREATE_LOCATION_TASK_COMMENT_SUCCESS,
                        types.CREATE_LOCATION_TASK_COMMENT_FAILURE
                    ]
                }
            });
        }
    },
    updateComment: (commentId, comment) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-comment',
                    method: 'POST',
                    body: {
                        commentId,
                        comment
                    },
                    types: [
                        types.UPDATE_LOCATION_TASK_COMMENT_REQUEST,
                        types.UPDATE_LOCATION_TASK_COMMENT_SUCCESS,
                        types.UPDATE_LOCATION_TASK_COMMENT_FAILURE
                    ]
                }
            });
        }
    },
    loadHistory: (taskId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/history',
                    method: 'POST',
                    body: { locationTaskId: taskId },
                    types: [
                        types.LOAD_LOCATION_TASK_HISTORY_REQUEST,
                        types.LOAD_LOCATION_TASK_HISTORY_SUCCESS,
                        types.LOAD_LOCATION_TASK_HISTORY_FAILURE
                    ]
                }
            });
        }
    },
    uploadFile: (request) => {
        return (dispatch) => {
            let body = new FormData();
            for (let key in request) {
                body.append(key, request[key]);
            }
            
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/upload-file',
                    method: 'POST',
                    body: body,
                    types: [
                        types.UPLOAD_LOCATION_TASK_FILE_REQUEST,
                        types.UPLOAD_LOCATION_TASK_FILE_SUCCESS,
                        types.UPLOAD_LOCATION_TASK_FILE_FAILURE
                    ]
                }
            });
        }
    },
    updateFile: (request) => {
        return (dispatch) => {
            let body = new FormData();
            for (let key in request) {
                body.append(key, request[key]);
            }
            
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-file',
                    method: 'POST',
                    body: body,
                    types: [
                        types.UPDATE_LOCATION_TASK_FILE_REQUEST,
                        types.UPDATE_LOCATION_TASK_FILE_SUCCESS,
                        types.UPDATE_LOCATION_TASK_FILE_FAILURE
                    ]
                }
            });
        }
    },
    deleteFile : (request) => {
        return (dispatch) => {
            let body = new FormData();
            for (let key in request) {
                body.append(key, request[key]);
            }
            
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/delete-file',
                    method: 'POST',
                    body: body,
                    types: [
                        types.DELETE_LOCATION_TASK_FILE_REQUEST,
                        types.DELETE_LOCATION_TASK_FILE_SUCCESS,
                        types.DELETE_LOCATION_TASK_FILE_FAILURE
                    ]
                }
            });
        }
    },
    createLink: (link) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/create-link',
                    method: 'POST',
                    body: {
                        link: link
                    },
                    types: [
                        types.CREATE_LOCATION_TASK_LINK_REQUEST,
                        types.CREATE_LOCATION_TASK_LINK_SUCCESS,
                        types.CREATE_LOCATION_TASK_LINK_FAILURE
                    ]
                }
            });
        }
    },
    updateLink: (link) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-link',
                    method: 'POST',
                    body: {
                        link: link
                    },
                    types: [
                        types.UPDATE_LOCATION_TASK_LINK_REQUEST,
                        types.UPDATE_LOCATION_TASK_LINK_SUCCESS,
                        types.UPDATE_LOCATION_TASK_LINK_FAILURE
                    ]
                }
            });
        }
    },
    createLocationTask: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/create-location-task',
                    method: 'POST',
                    body: request,
                    types: [
                        types.CREATE_LOCATION_TASK_REQUEST,
                        types.CREATE_LOCATION_TASK_SUCCESS,
                        types.CREATE_LOCATION_TASK_FAILURE
                    ]
                }
            });
        }
    },
    listMentionableUsers: (locationKey) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/search-mentionable-users',
                    method: 'POST',
                    body: {
                        locationKey: locationKey
                    },
                    types: [
                        types.SEARCH_LOCATION_TASK_MENTIONABLE_USERS_REQUEST,
                        types.SEARCH_LOCATION_TASK_MENTIONABLE_USERS_SUCCESS,
                        types.SEARCH_LOCATION_TASK_MENTIONABLE_USERS_FAILURE
                    ]
                }
            });
        }
    },
    updateContingent: (taskId, contingentId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/update-contingent',
                    method: 'POST',
                    body: {
                        taskId: taskId,
                        contingentId: contingentId
                    },
                    types: [
                        types.UPDATE_LOCATION_CONTINGENT_REQUEST,
                        types.UPDATE_LOCATION_CONTINGENT_SUCCESS,
                        types.UPDATE_LOCATION_CONTINGENT_FAILURE
                    ]
                }
            });
        }
    },
    getResourceAllocations: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/resource-allocations',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_REQUEST,
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_SUCCESS,
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_FAILURE
                    ]
                }
            });
        }
    },
    getResourceAllocationsDetails: (searchParams) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/resource-allocations-details',
                    method: 'POST',
                    body: searchParams,
                    types: [
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_REQUEST,
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_SUCCESS,
                        types.LOAD_TASK_RESOURCE_ALLOCATIONS_DETAILS_FAILURE
                    ]
                }
            });
        }
    },
    createFeedback: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/create-feedback',
                    method: 'POST',
                    body: request,
                    types: [
                        types.CREATE_FEEDBACK_REQUEST,
                        types.CREATE_FEEDBACK_SUCCESS,
                        types.CREATE_FEEDBACK_FAILURE
                    ]
                }
            });
        }
    },
    validateTranslation: (locationTaskId, language) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: `location-task/translation/validate/${locationTaskId}?language=${language}`,
                    method: 'GET',
                    types: [
                        types.VALIDATE_TRANSLATION_TEXT_REQUEST,
                        types.VALIDATE_TRANSLATION_TEXT_SUCCESS,
                        types.VALIDATE_TRANSLATION_TEXT_FAILURES
                    ]
                }
            })
        }
    },
    translateText: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/translation',
                    method: 'POST',
                    body: request,
                    types: [
                        types.TRANSLATE_TEXT_REQUEST,
                        types.TRANSLATE_TEXT_SUCCESS,
                        types.TRANSLATE_TEXT_FAILURES
                    ]
                }
            })
        }
    },
    translationRating: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/translation/rating',
                    method: 'POST',
                    body: request,
                    types: [
                        types.TRANSLATION_RATING_REQUEST,
                        types.TRANSLATION_RATING_SUCCESS,
                        types.TRANSLATION_RATING_FAILURES
                    ]
                }
            })
        }
    },
    setTasksMenuItems: (items) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_TASK_MENU_ITEMS,
                payload: {
                    items: items
                }
            })
        }
    },
    setTasksMenuSelected: (selectedValue) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_TASK_MENU_SELECTED,
                payload: {
                    selectedValue
                }
            })
        }
    },
    saveCustomFilters: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/save-filters',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SAVE_FILTERS_REQUEST,
                        types.SAVE_FILTERS_SUCCESS,
                        types.SAVE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    setTasksPageTaskMenuItems: (items) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_TASK_PAGE_TASK_MENU_ITEMS,
                payload: {
                    items: items
                }
            })
        }
    },
    getCustomFilter: (filterName) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/get-saved-filter/' + filterName,
                    method: 'GET',
                    types: [
                        types.GET_CUSTOM_FILTER_REQUEST,
                        types.GET_CUSTOM_FILTER_SUCCESS,
                        types.GET_CUSTOM_FILTER_FAILURE
                    ]
                }
            });
        }
    },
    deleteCustomFilter: (filterName) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/user-filter',
                    method: 'DELETE',
                    body: { filterName: filterName },
                    types: [
                        types.DELETE_FILTER_REQUEST,
                        types.DELETE_FILTER_SUCCESS,
                        types.DELETE_FILTER_FAILURE
                    ]
                }
            });
        }
    },
    bulkShiftDates: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'location-task/bulk-shift-dates',
                    method: 'POST',
                    body: request,
                    types: [
                        types.BULK_SHIFT_DATES_REQUEST,
                        types.BULK_SHIFT_DATES_SUCCESS,
                        types.BULK_SHIFT_DATES_FAILURE
                    ]
                }
            });
        }
    }
}
